// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tenant-settings[data-v-039baf95]{grid-gap:25px;display:grid}", "",{"version":3,"sources":["webpack://./resources/js/Components/Settings/TenantSettings/Form.vue"],"names":[],"mappings":"AACA,kCAEI,aAAA,CADA,YACA","sourcesContent":["\n.tenant-settings {\n    display: grid;\n    grid-gap: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
